<template>
  <div class="modal-agreement-container" :class="{'loading' : isLoading}">
    <div class="modal-agreement-content" v-if="!isLoading">
      <main-title :class="{'not-active-action' : isNotActiveAction}">
        {{ mainTitle }}
      </main-title>
      <div class="actions-container" v-if="!isNotActiveAction">
        <button-main v-for="(item, index) in actions"
                     @click="actionActive(index)"
                     :is-non-uppercase="true"
                     :key="index">
          {{ item }}
        </button-main>
      </div>
    </div>
    <loader v-else/>
  </div>
</template>

<script>
import MainTitle from "@/components/shared/text/MainTitle.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import Loader from "@/components/shared/loader/Loader.vue";
export default {
  name: "ModalAgreement",
  components: {Loader, ButtonMain, MainTitle},
  data() {
    return {
      isNotActiveAction: false,
      isLoading: false,
      mainTitle: '',
      actions: ['Отменить', 'Удалить'],
      onComplete: () => null,
    }
  },
  mounted() {
    this.setInitialParams(this.isActiveModalName);
  },
  methods: {
    actionActive(index) {
      switch (index) {
        case 0:
          this.$emit('closeModal')
          break;
        case 1:
          this.isLoading = true;
          this.onComplete();
          this.$emit('closeModal')
          break;
      }
    },
    setInitialParams(params) {
      console.log(params)
      this.mainTitle = params?.title
          || 'Вы действительно хотите совершить это действие?'
      this.onComplete = params.onComplete;
    }
  }
}
</script>

<style scoped lang="scss">
.modal-agreement-container {
  height: 115px;
  text-align: center;
  .modal-agreement-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
  &.loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main-title-container {
    white-space: pre-wrap;
    margin-bottom: auto;
    color: var(--color-dark-green);
    @media (max-width: 769px) {
      margin: auto;
    }
    &.not-active-action {
      margin: auto 0;
    }
  }
  .actions-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .main-button-container{
      width: 48% !important;
      &:first-child{
        margin-right: 20px;
      }
    }
  }
  .loader-container {
  }
}
</style>